module.exports = __webpack_public_path__ + "img/icon3.c151ba68.png";